import { render, staticRenderFns } from "./contratos.vue?vue&type=template&id=19221a96&scoped=true"
import script from "./contratos.vue?vue&type=script&lang=js"
export * from "./contratos.vue?vue&type=script&lang=js"
import style0 from "./contratos.vue?vue&type=style&index=0&id=19221a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19221a96",
  null
  
)

export default component.exports